import ewAnalytics from 'utils/analytics';
import { addToCartDataLayer } from 'utils/cartHelpers';
import { ANALYTICS } from 'utils/constants/analytics';
import { logError } from 'utils/helpers';
import { ProductDataType } from 'utils/types';

export const trackCardClick = (slug: string) => {
  ewAnalytics.track({
    event: ANALYTICS.EVENTS.CLICKED_BUTTON,
    data: {
      label: ANALYTICS.LABELS.PIP_PRODUCT_CARD,
      slug,
    },
  });
};

export const trackAddToCartButtonClick = (slug: string) => {
  ewAnalytics.track({
    event: ANALYTICS.EVENTS.CLICKED_BUTTON,
    data: {
      label: ANALYTICS.LABELS.PIP_ADD_TO_CART_BUTTON,
      slug,
    },
  });
};

export const addToCartGTM = (
  variant: ProductDataType,
  productId: number,
  eventId: string,
) => {
  if (!window || !window.dataLayer || !variant) {
    return;
  }

  try {
    addToCartDataLayer(productId, variant.name, String(variant.price), eventId);
  } catch (err) {
    logError(
      'There was an error when attempting to add the addToCart event to GTM',
      {
        component: 'ProductDisplayGrid',
        function: 'addToCartGTM',
        productId,
        variant: variant.name,
        price: variant.price,
      },
    );
  }
};
